import React from 'react';
import type { FC } from 'react';

interface BinIconProps {
    className?: string;
}

export const BinIcon: FC<BinIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="17"
            viewBox="0 0 20 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Bin Icon</title>
            <path
                d="M7 5.99999H13V4.5C13 3.94771 12.5523 3.5 12 3.5H8C7.44772 3.5 7 3.94771 7 4.5V5.99999Z"
                strokeLinejoin="round"
            />
            <path d="M5 6L5.91379 15.5948C5.96267 16.108 6.39373 16.5 6.90929 16.5H13.0907C13.6063 16.5 14.0373 16.108 14.0862 15.5948L15 6" />
            <path d="M4 6H16" />
        </svg>
    );
};
